export function getRuleData(key, ruleDataPool) {
    return ruleDataPool[key];
}
